import React from 'react'

export default function Avatar ({ profile }) {
  return (
    <>
      <img alt={`${profile.name} avatar`} className='img img-responsive rounded-circle' src={profile.avatar} />
    </>
  )
}
